import { type Component } from 'solid-js'

const ThanksHeader: Component = () => {
  return (
    <span class="text-white text-[32px] font-extrabold text-center">Thank You For Your Order!</span>
  )
}

export default ThanksHeader
